import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const FeedGuard = ({ token, children }) => {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const cohortRes = await axios.get('https://genz-staging.feeltiptop.com/api/user/check-cohort', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (cohortRes.data.inCohort) {
          // User is in a cohort, not allowed to access feed
          navigate('/login');
        } else {
          // User is NOT in a cohort, allowed to access
          setAllowed(true);
        }
      } catch (err) {
        console.error('Error checking cohort status:', err);
        navigate('/login');
      } finally {
        setChecking(false);
      }
    };

    if (token) {
      checkStatus();
    } else {
      navigate('/login');
    }
  }, [token, navigate]);

  if (checking) {
    return <div>Checking access...</div>;
  }

  return allowed ? children : null;
};

export default FeedGuard;
